import API, { handleRequest } from "../lib/api";

export const getComplementaryReportApi = (restaurantId, params) =>
  handleRequest(() =>
    API.get(`/restaurant/${restaurantId}/complementary-report`, {
      params,
    }),
  );

export const getReplaceItemRepor = (restaurantId, params) =>
  handleRequest(() =>
    API.get(`restaurant/${restaurantId}/replaced-items-report`, {
      params,
    }),
  );

export const getSmsUsageHistoryApi = (restaurantId, params) =>
  handleRequest(() =>
    API.get(`restaurant/${restaurantId}/sms-usage-history`, {
      params,
    }),
  );

